import src from "IMAGE";
export default { src, width: 950, height: 88, blurWidth: 8, blurHeight: 1, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAYAAADjAO9DAAAALElEQVR42gEhAN7/AAwTHmgKERpdChAaWwoQGVg1MTVU57q47PjEwv/uvbr0hhwNXGf9umEAAAAASUVORK5CYII="};
